import type { BookingValueOddsTypeLimit } from '@/types/booked-bet';
import { OperationType } from '@/types/booked-bet';
import BookingStrategy from './booking-strategy';
import { WebOddsType, IncDecType } from '@nf/utils-common/constants';
import { idealRound } from '@nf/utils-common/numbers';
import { matchSome } from '@nf/utils-common/fpw/monadic';
import { isInRange, isBetweenInclusive } from '@nf/utils-common/fpw/equality'; 

class CsBookingStrategy extends BookingStrategy {
	generateStepSize(value: number): number {
		return matchSome(value)
			.on(isBetweenInclusive(1.01, 3), () => 0.01)
			.on(isBetweenInclusive(3.01, 5), () => 0.05)
			.on(isBetweenInclusive(5.01, 10), () => 0.1)
			.on(isBetweenInclusive(10.01, 350), () => this.options.betType === 5 ? 1 : 2)
			.otherwise(() => 0);
	}

	getOddsTypeLimit(value: number): BookingValueOddsTypeLimit {
		return {
			min: 1.01, 
			max: 350
		};
	}

	calculateDefaultRange(value: number, incDecType: IncDecType): Array<number> {
		return incDecType === IncDecType.Increment
			? this.generateIncrementedValuesForDecimal(value, this.oddsRangeSize)
			: this.generateDecrementedValuesForDecimal(value, this.oddsRangeSize);
	}

	calculateBookingOdds(
		odds: number, 
		operationType: OperationType, 
		baseOddsType?: WebOddsType
	): number {
		let value = this.calculateWithStep(odds, operationType);

		value = matchSome(value)
			.on(isInRange(10, 11), () => 11)
			.otherwise(() => value);
		
		return idealRound(value, 2);
	}
}

export default CsBookingStrategy;